import { render, staticRenderFns } from "./default_detail.vue?vue&type=template&id=088dd8a8&scoped=true&"
import script from "./default_detail.vue?vue&type=script&lang=js&"
export * from "./default_detail.vue?vue&type=script&lang=js&"
import style0 from "./default_detail.vue?vue&type=style&index=0&id=088dd8a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088dd8a8",
  null
  
)

export default component.exports